var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "7156610_linkedin_social_media_icon",
    transform: "translate(-.25 -.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.006 34.25H9.494A9.254 9.254 0 0 1 .25 25.006V9.494A9.254 9.254 0 0 1 9.494.25h15.512a9.254 9.254 0 0 1 9.244 9.244v15.512a9.254 9.254 0 0 1-9.244 9.244M9.494 2.714a6.79 6.79 0 0 0-6.78 6.78v15.512a6.79 6.79 0 0 0 6.78 6.78h15.512a6.79 6.79 0 0 0 6.78-6.78V9.494a6.79 6.79 0 0 0-6.78-6.78Z",
    "data-name": "Path 45892"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.43,
    height: 10.96,
    "data-name": "Rectangle 26694",
    rx: 1.71,
    transform: "translate(8.603 14.511)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.323 9.076a1.72 1.72 0 1 0 1.71 1.71 1.72 1.72 0 0 0-1.71-1.71",
    "data-name": "Path 45893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.685 16.853a2.17 2.17 0 0 1 1.95.4 3.6 3.6 0 0 1 .84 2.69v3.82a1.72 1.72 0 0 0 1.72 1.71 1.71 1.71 0 0 0 1.71-1.71v-5a5.9 5.9 0 0 0-.84-3l-.05-.06a4 4 0 0 0-3.19-1.51 3.84 3.84 0 0 0-3.47 1.7l-.46.67v-.4a1.71 1.71 0 0 0-1.71-1.71 1.71 1.71 0 0 0-1.71 1.71v7.54a1.71 1.71 0 0 0 1.71 1.71 1.7 1.7 0 0 0 1.71-1.71v-5.01c.67-1.7 1.79-1.83 1.79-1.84",
    "data-name": "Path 45894"
  }))));
};
export default SvgLinkedin;